/**
 * @module capitalize
 * @since 1.4.0
 */

/**
 * Uppercase first character
 * @private
 * @param  {String} string Any string
 * @return {String} A string where the first character is uppercased
 */
const cap = (string) => string.charAt(0).toUpperCase() + string.slice(1);

/**
 * Uppercase first character of a sentence, or each word in a string.
 * @param  {String}  [string=''] A word or a sentence.
 * @param  {Boolean} [all=false] Whether to capitalize all letters or just the first one.
 * @return {String}
 *
 * @example
 * capitalize('martin prince') // 'Martin prince'
 * capitalize('martin prince', true) // 'Martin Prince'
 */
export const capitalize = (string = '', all = false) => all ? string.split(' ').map(cap).join(' ') : cap(string);
